// <info-popover> primitive. Wraps a trigger button + a [popover] panel and
// anchors the panel to the trigger on open by setting inline top/left.
// The HTML Popover API owns open/close, light dismiss, Escape, focus, and
// top-layer rendering; JS is positioning only.
//
// Falls back to centered (browser default) if positioning can't compute —
// e.g. trigger detached from layout.

if (!customElements.get('info-popover')) {
  customElements.define(
    'info-popover',
    class InfoPopover extends HTMLElement {
      constructor() {
        super();
        this.trigger = this.querySelector('[popovertarget]');
        this.panel = this.querySelector('[popover]');
        this.handleToggle = this.handleToggle.bind(this);
        this.position = this.position.bind(this);
      }

      connectedCallback() {
        if (!this.panel) return;
        this.panel.addEventListener('beforetoggle', this.handleToggle);
      }

      disconnectedCallback() {
        if (this.panel) {
          this.panel.removeEventListener('beforetoggle', this.handleToggle);
        }
        window.removeEventListener('resize', this.position);
        window.removeEventListener('scroll', this.position, true);
      }

      handleToggle(event) {
        if (event.newState === 'open') {
          requestAnimationFrame(this.position);
          window.addEventListener('resize', this.position);
          window.addEventListener('scroll', this.position, true);
        } else {
          window.removeEventListener('resize', this.position);
          window.removeEventListener('scroll', this.position, true);
        }
      }

      position() {
        if (!this.trigger || !this.panel) return;
        const trigger = this.trigger.getBoundingClientRect();
        const panel = this.panel.getBoundingClientRect();
        const vw = document.documentElement.clientWidth;
        const vh = document.documentElement.clientHeight;
        const gap = 8;
        const margin = 12;

        let top = trigger.bottom + gap;
        if (top + panel.height > vh - margin) {
          const above = trigger.top - panel.height - gap;
          if (above >= margin) top = above;
        }

        let left = trigger.left;
        if (left + panel.width > vw - margin) {
          left = vw - panel.width - margin;
        }
        if (left < margin) left = margin;

        this.panel.style.top = `${top}px`;
        this.panel.style.left = `${left}px`;
      }
    }
  );
}
